import { QuestionTemplate } from "../../model/templates/QuestionTemplate";
import { api } from "../api";
import { parseQuestionTemplate } from "../../parsers/template/parseQuestionTemplate";
import { fromQuestionTemplateToGenerated } from "../../parsers/template/to-generated/fromQuestionTemplateToGenerated";

export const putQuestionTemplate = async (questionTemplateId: string, questionTemplate: QuestionTemplate) => {
  const result = await api.services.questionTemplate.updateQuestionTemplate(
    questionTemplateId,
    fromQuestionTemplateToGenerated(questionTemplate)
  );
  return parseQuestionTemplate(result.data);
};
